import { BaseMapper } from '@/core/mapper';

import { Vendor } from '@/core/vendor';
import { VendorUser } from '@/core/vendor-user';

const schema = {
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  status: {
    parseFrom: 'attributes.status',
  },
  vendor: {
    fromResponse: (entity) => {
      const vendor = _.get(entity, 'relationships.vendor.data');
      return vendor && new Vendor(vendor);
    },
    omitFromRequest: true,
  },
  user: {
    fromResponse: (entity) => {
      const vendorUser = _.get(entity, 'relationships.user.data');
      return vendorUser && new VendorUser(vendorUser);
    },
    omitFromRequest: true,
  },
};

class AccessRequest extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

AccessRequest.schema = schema;

export default AccessRequest;
